import { connect } from 'react-redux';
import { compose } from 'redux';

import ActivationFormPayment from '../../components/compositions/activation/ActivationFormPayment';
import initForm from '../form/FormInitializer';

import {
  createFieldMap as createPaymentFieldMap,
  normalizeValues as normalizePaymentValues,
} from '../form/PaymentModule';
import { FORM_FIELD_PAYMENT_TYPE_ADVANCE } from '../../helpers/constants';

export const createFieldMap = (ui, params) =>
  createPaymentFieldMap(ui, params, {
    directDebit: true,
    creditCard: true,
    advancePayment: false,
    paypal: false,
  });

const mapStateToProps = (state, { params, fieldMap }) => {
  const initialValues = {
    [fieldMap.mediaId.name]: '',
    [fieldMap.ddMandate.name]: !!fieldMap.ddMandate.isControlled,
    [fieldMap.paymentType.name]: fieldMap.paymentType.options[0].value,
  };

  const { paymentHeadline, paymentCopy } = params;

  return {
    initialValues,
    // cms wordings
    paymentHeadline,
    paymentCopy,
  };
};

const normalize = (formConfig, stepFormValues, stepProps, props) => {
  // note: we need to get the "full" fieldmap which includes all fields of all steps
  // as we need to access fields that are not in this step
  const { fieldMap, formValues } = props;

  if (formValues[fieldMap.topupType.name] === 'none') {
    return { payment_type: FORM_FIELD_PAYMENT_TYPE_ADVANCE };
  }

  return normalizePaymentValues(formConfig, stepFormValues, stepProps);
};

// init component once, outside
const component = compose(
  connect(
    mapStateToProps,
  ),
  initForm(),
)(ActivationFormPayment);

const isEnabled = (fieldMap, formValues) => formValues[fieldMap.topupType.name] !== 'none';

export const id = 'payment';

/**
 * @return {FormConfig}
 */
export const mapStateToFormConfig = (state, props) => ({
  component,
  fieldMap: createFieldMap(props.ui, props.params),
  normalize,
  label: props.ui.guiWordPaymentData,
  isEnabled,
});

export default mapStateToFormConfig;
